export default __webpack_public_path__ + "static/img-pompano-500x325-30dfcd142639d6e52d59c96b73a1ba7a.png";